<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/reportsList" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ ViewReports.reportName }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("system.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deletereportsPopup = true"
                      >{{ $t("system.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("system.label.ReportType") }}</b>
                    </td>
                    <td>{{ ViewReports.reportType }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.ReportCategory") }}</b>
                    </td>
                    <td>{{ ViewReports.reportCategory }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("system.label.CoreReport") }}</b>
                    </td>
                    <td>{{ ViewReports.coreReport }}</td>
                  </tr>

                  <tr>
                    <td class="border-none">
                      <b>{{ $t("system.label.UserReport") }} </b>
                    </td>
                    <td class="border-none">
                      {{ ViewReports.useReport }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletereportsPopup"
      :title="$t('system.label.Reports')"
      @deletePressed="deletereports()"
      @cancelPressed="deletereportsPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      ViewReports: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deletereportsPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      Report: (state) => state.manageReport.ViewReport,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
    breadcrumbs() {
      return [
        {
          name: this.$t("system.label.ManageReports"),
          to: "/reportsList",
        },
        { name: this.ViewReports.reportName, to: "/" },
      ];
    },
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData(id) {
      this.$router.push(`/editManageReports/${id}`);
    },
    async deletereports() {
      this.deletereportsPopup = false;
      await this.$store.dispatch("manageReport/deletereportsAction", this.id);
      this.$router.push(`/reportsList`);
    },

    async getreports() {
      try {
        await this.$store.dispatch("manageReport/setreports", this.id);
        this.ViewReports = this.Report;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getreports();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
